import { createSelector } from 'reselect';
import todoIsOverdue from 'lib/todoIsOverdue.js';
import { isToday } from 'date-fns';
import { filteredUserId } from 'selectors/filterSelectors';

const eventsSelectorTodoUpdated = (state) => ((state.app.event || {})[state.currentServiceProvider.id] || {}).updated_todo;

export const todoEventsSelector = createSelector(eventsSelectorTodoUpdated, filteredUserId, (events, filteredUserId) => {
  const result = (events || [])
    .filter((n) => n.type === 'updated_todo')
    .filter((n) => n.acknowledged !== true)
    .filter((n) => (n || {}).todo)
    .map((n) => ({ ...n, event_data: { ...n.todo.event_data.todo, overdue: todoIsOverdue(n.todo.event_data.todo) } }))
    .filter((n) => n.event_data.overdue === true || isToday(new Date(n.event_data.target_datetime)))
    .filter((n) => (filteredUserId ? n.event_data.assignee_user_id === filteredUserId || n.event_data.creator_user_id === filteredUserId : n));
  return result;
});

export const todoEventsDueTodaySelector = createSelector(eventsSelectorTodoUpdated, filteredUserId, (events, filteredUserId) => {
  const result = (events || [])
    .filter((n) => n.type === 'updated_todo')
    .filter((n) => n.acknowledged !== true)
    .filter((n) => (n || {}).todo)
    .map((n) => ({ ...n, event_data: { ...n.todo.event_data.todo, overdue: todoIsOverdue(n.todo.event_data.todo) } }))
    .filter((n) => isToday(new Date(n.event_data.target_datetime)))
    .filter((n) => (filteredUserId ? n.event_data.assignee_user_id === filteredUserId || n.event_data.creator_user_id === filteredUserId : n));
  return result;
});
